import { render } from "./Shape.vue?vue&type=template&id=5618d366&bindings={\"shape\":\"props\",\"filled\":\"props\",\"shapeColor\":\"options\",\"filledClass\":\"options\"}"
import script from "./Shape.vue?vue&type=script&lang=js"
export * from "./Shape.vue?vue&type=script&lang=js"

import "./Shape.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script